import { NavLink } from 'react-router-dom'
import { LayoutTemplate, Database, FileText, LogOut, Webhook, History, FileCode2 } from 'lucide-react'
import { useAuth } from '@/context/AuthContext'
import { cn } from '@/lib/utils'

const NAV = [
  { to: '/templates',    icon: LayoutTemplate, label: 'Templates'    },
  { to: '/datasources',  icon: Database,        label: 'Data Sources' },
  { to: '/snippets',     icon: FileCode2,       label: 'Snippets'     },
  { to: '/publish-subscribers', icon: Webhook,  label: 'Publish Subscribers' },
  { to: '/webhook-deliveries', icon: History,   label: 'Webhook Deliveries' },
]

export function Sidebar() {
  const { user, logout } = useAuth()

  return (
    <aside className="flex h-screen w-56 flex-col border-r border-border bg-surface flex-shrink-0">
      {/* Logo */}
      <div className="flex items-center gap-2 px-5 py-4 border-b border-border">
        <FileText className="h-4 w-4 text-accent" />
        <span className="text-sm font-black tracking-wider text-ink">
          REPORT<span className="text-muted font-normal">STUDIO</span>
        </span>
      </div>

      {/* Nav */}
      <nav className="flex-1 p-3 space-y-0.5">
        {NAV.map(({ to, icon: Icon, label }) => (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) => cn(
              'flex items-center gap-3 rounded-md px-3 py-2 text-xs font-semibold tracking-wide transition-colors',
              isActive
                ? 'bg-accent/10 text-accent'
                : 'text-muted hover:bg-border hover:text-ink'
            )}
          >
            <Icon className="h-3.5 w-3.5" />
            {label}
          </NavLink>
        ))}
      </nav>

      {/* User */}
      <div className="border-t border-border p-3">
        <div className="flex items-center gap-2 rounded-md px-3 py-2">
          <div className="flex h-7 w-7 items-center justify-center rounded-full bg-accent/20 text-accent text-xs font-bold flex-shrink-0">
            {(user?.username?.[0] ?? '?').toUpperCase()}
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-xs font-semibold text-ink truncate">{user?.username}</p>
          </div>
          <button
            onClick={logout}
            className="text-muted hover:text-red transition-colors"
            title="Logout"
          >
            <LogOut className="h-3.5 w-3.5" />
          </button>
        </div>
      </div>
    </aside>
  )
}
